module.exports = __webpack_public_path__ + "static/Hero-Why-Archer-Health-min-720ab54130f4f356f39069df81cde209.png";